import { useEffect } from 'react';
import PauseIcon from '../../../assets/svgs/paus-feedback-modal.svg';
import { getScreenShotFromVideo } from '../../../utilis/helpers';
import 'twin.macro';

const PauseIconComponent = ({
  hiddenVideoPlayerRef,
  videoRecordSrc,
  setImageUrl,
  playVideo,
  showPauseIcon,
}) => {
  // screen shots for user video
  useEffect(() => {
    if (showPauseIcon && playVideo?.feed_back_video?.from && hiddenVideoPlayerRef?.current) {
      hiddenVideoPlayerRef.current.currentTime = playVideo?.feed_back_video?.from;
      hiddenVideoPlayerRef.current.play();
      getScreenShotFromVideo({
        timeInSeconds: playVideo?.feed_back_video?.from,
        videoElement: hiddenVideoPlayerRef.current,
      }).then(response => setImageUrl(response));
    }
  }, [playVideo?.feed_back_video?.from, showPauseIcon]);

  return (
    <div>
      <img loading="lazy" decoding="async" src={PauseIcon} alt="pause" />
      <video tw="hidden" preload="metadata" ref={hiddenVideoPlayerRef} src={videoRecordSrc} />
    </div>
  );
};

export default PauseIconComponent;
